import React from "react";
import { useHistory } from "react-router-dom";
import LogoImage from "../static/images/CioffLogo50.png";
import "components/WelcomePage.css";
import { useTranslation } from "react-i18next";

export default function WelcomePage() {
  const { t } = useTranslation();
  const history = useHistory();
  const login = () => history.replace("/image-gallery");

  return (
    <div className="welcome-page">
      <div className="logo-50">
        <img alt="CIOFF logo" src={LogoImage} height={400} width={500} />
      </div>
      <div className="welcome-text">
        <p>{t("description.part1")}</p>
        <ul>
          <li>{t("description.part2")}</li>
          <li> {t("description.part3")}</li>
          <li>{t("description.part4")}</li>
          <li>{t("description.part5")}</li>
        </ul>
        <p>{t("description.part6")}</p>
        <p>{t("description.part7")}</p>
      </div>
      <div className="welcome-cioff">
        <p>{t("description.cioff")}</p>
      </div>

      <div className="gallery-button">
        <button
          name="commit"
          type="submit"
          value="Log In"
          onClick={login}
        >
          {t("title")}
        </button>
      </div>
    </div>
  );
}
